/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumChatActivityStatus = "assigned" | "closed" | "pending" | "unassigned" | "%future added value";
export type ActionsChatActivity_EmbedChatActivity = {
    readonly _id: string;
    readonly status: EnumChatActivityStatus | null;
    readonly " $fragmentRefs": FragmentRefs<"ButtonChatActivityOpen_EmbedChatActivity" | "ButtonChatActivityReassign_EmbedChatActivity">;
    readonly " $refType": "ActionsChatActivity_EmbedChatActivity";
};
export type ActionsChatActivity_EmbedChatActivity$data = ActionsChatActivity_EmbedChatActivity;
export type ActionsChatActivity_EmbedChatActivity$key = {
    readonly " $data"?: ActionsChatActivity_EmbedChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ActionsChatActivity_EmbedChatActivity">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActionsChatActivity_EmbedChatActivity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ButtonChatActivityOpen_EmbedChatActivity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ButtonChatActivityReassign_EmbedChatActivity"
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
(node as any).hash = 'dc07ecc0495669d1f1c78f969c18f12a';
export default node;
